module.exports = __webpack_public_path__ + "img/delete-icon.08820377.svg";